const messages = {
  back: 'cambiar fecha y hora',
  buttonText: 'CONFIRMAR CITA',
  error: 'Hubo un error al crear la cita, intente más tarde',
  buttonExpired: 'Regresar al inicio '
}

export default messages
